import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  recentActivity: "Recent Activity",
  latestEvents: "Latest events across your workspace",
  noRecentActivity: "No recent activity yet.",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    recentActivity: "Activité récente",
    latestEvents: "Derniers événements de votre espace de travail",
    noRecentActivity: "Aucune activité récente pour le moment.",
  },
  es_ES: {
    recentActivity: "Actividad reciente",
    latestEvents: "Últimos eventos en tu espacio de trabajo",
    noRecentActivity: "Aún no hay actividad reciente.",
  },
  pt_BR: {
    recentActivity: "Atividade recente",
    latestEvents: "Eventos mais recentes no seu espaço de trabalho",
    noRecentActivity: "Nenhuma atividade recente ainda.",
  },
  de_DE: {
    recentActivity: "Letzte Aktivitäten",
    latestEvents: "Neueste Ereignisse in Ihrem Arbeitsbereich",
    noRecentActivity: "Noch keine Aktivitäten.",
  },
  it_IT: {
    recentActivity: "Attività recenti",
    latestEvents: "Ultimi eventi nel tuo spazio di lavoro",
    noRecentActivity: "Ancora nessuna attività recente.",
  },
  ar: {
    recentActivity: "النشاط الأخير",
    latestEvents: "أحدث الأحداث في مساحة عملك",
    noRecentActivity: "لا يوجد نشاط حديث بعد.",
  },
  ja_JP: {
    recentActivity: "最近のアクティビティ",
    latestEvents: "ワークスペース全体の最新イベント",
    noRecentActivity: "最近のアクティビティはまだありません。",
  },
  hi_IN: {
    recentActivity: "हाल की गतिविधि",
    latestEvents: "आपके वर्कस्पेस के नवीनतम इवेंट",
    noRecentActivity: "अभी कोई हाल की गतिविधि नहीं है।",
  },
  zh_CN: {
    recentActivity: "最近活动",
    latestEvents: "您工作区内的最新事件",
    noRecentActivity: "暂无最近活动。",
  },
  zh_TW: {
    recentActivity: "近期活動",
    latestEvents: "您工作區內的最新事件",
    noRecentActivity: "尚無近期活動。",
  },
  nl_NL: {
    recentActivity: "Recente activiteit",
    latestEvents: "Laatste gebeurtenissen in je werkruimte",
    noRecentActivity: "Nog geen recente activiteit.",
  },
  nb_NO: {
    recentActivity: "Siste aktivitet",
    latestEvents: "Siste hendelser i arbeidsområdet ditt",
    noRecentActivity: "Ingen nylig aktivitet ennå.",
  },
  sv_SE: {
    recentActivity: "Senaste aktivitet",
    latestEvents: "Senaste händelserna i din arbetsyta",
    noRecentActivity: "Ingen aktivitet ännu.",
  },
  fi_FI: {
    recentActivity: "Viimeaikainen toiminta",
    latestEvents: "Uusimmat tapahtumat työtilassasi",
    noRecentActivity: "Ei vielä toimintaa.",
  },
  da_DK: {
    recentActivity: "Seneste aktivitet",
    latestEvents: "Seneste hændelser i dit arbejdsområde",
    noRecentActivity: "Ingen aktivitet endnu.",
  },
  is_IS: {
    recentActivity: "Nýleg virkni",
    latestEvents: "Nýjustu atburðir á vinnusvæðinu þínu",
    noRecentActivity: "Engin nýleg virkni enn.",
  },
};
